import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingMovements: false
}

// getters
const getters = {
  getLoadingMovements () {
    return state.loadingMovements
  }
}

// actions
const actions = {
  async getMovements ({ commit, rootState }, data) {
    commit('LOADING_MOVEMENTS_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codconas: '',
            codconasf: data.concept,
            codcuent: data.codCuent,
            codentid: '',
            codprogr: appProgram,
            descccon: '',
            descsita: '',
            fecaltmv: {
              anno: 0,
              dia: 0,
              format: 'dd-MM-yyyy',
              mes: '0',
              nombreDia: '',
              nombreMes: '',
              valueDate: ''
            },
            fechadesf: {
              anno: 0,
              dia: 0,
              format: 'dd-MM-yyyy',
              mes: '0',
              nombreDia: '',
              nombreMes: '',
              valueDate: data.fechades
            },
            fechahasf: {
              anno: 0,
              dia: 0,
              format: 'dd-MM-yyyy',
              mes: '0',
              nombreDia: '',
              nombreMes: '',
              valueDate: data.fechahas
            },
            punobten: 0,
            punpteca: 0,
            sitactmo: ''
          }
        }
      })
    }
    try {
      const response = await HTTP.post(config.endpoints.getMovements, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_MOVEMENTS_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  }
}

// mutations
const mutations = {
  'LOADING_MOVEMENTS_FINISHED' (state, actions) {
    state.loadingMovements = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
